<template>
  <div ref="chart">
    <Chart :height="height" :id="id" :option="option"
            :width="width" :extendData="extendData"></Chart>
  </div>
</template>

<script>
import Chart from '@/components/echarts/Chart';

export default {
  name: "BatteryBarChart",
  components: {Chart},
  props: {
    data : null,
    extendData: null,
  },
  data() {
    return {
      id: "BatteryBarChart",
      width: '100%',
      height: '100%',
      option: {},
    };
  },
  watch: {
    data() {
      this.getOption();
    }
  },
  mounted() {
    this.getOption();
  },
  methods: {
    getOption: function () {
      this.option = {
        grid: {
          left: 0,
          right: 12,
          top: 0,
          bottom: 0,
        },
        tooltip: {
          show: false,
        },
        legend: {
          show: false,
        },
        xAxis: {
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        yAxis: {
          data: ["sss"],
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        color: [
          "rgba(61, 207, 170, 1)",
        ],
        series: [{
          name: '底色',
          type: 'pictorialBar',
          symbol: 'rect',
          itemStyle: {
            normal: {
              color: 'rgba(73, 164, 243, .2)',
            }
          },
          symbolRepeat: true,
          symbolSize: [14, 20],
          // symbolBoundingData: 100,
          symbolMargin: 0.5,
          symbolPosition: 'start',
          z: -20,
          data: [100],
        }, {
          name: '数量',
          type: 'pictorialBar',
          symbol: 'rect',
          itemStyle: {
            normal: {
              color: 'rgba(61, 207, 170, 1)',
            }
          },
          symbolRepeat: true,
          symbolSize: [14, 20],
          // symbolBoundingData: 100,
          symbolMargin: 0.5,
          symbolPosition: 'start',
          z: -20,
          data: this.data,
          label: {
            normal: {
              show: false,
              position: 'right',
              formatter: function (value) {
                return value && (value.data).toFixed(1) + '%'
              }
            }
          }
        }, {
          name: '电量',
          type: 'bar',
          barWidth: 19,
          itemStyle: {
            normal: {
              color: 'rgba(0,0,0,0)',
              borderWidth: 2,
              borderColor: 'rgba(1, 239, 253, .2)',
              padding: 0
            }
          },
          label: {
            show: false
          },
          z: -10,
          data: [100]
        }, {
          name: '',
          type: 'line',
          // barWidth: 19,
          symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAFCAYAAAB1j90SAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAADFJREFUGJVjFNj/hwEK/jMQBxgZGBgYWNAFiAUwjcTaBrcEppEk22A2kmobAwMDAwMA74EE3gW8aacAAAAASUVORK5CYII=',

          symbolSize: [20, 6],
          symbolOffset: [5, 0],
          symbolRotate: 270,
          itemStyle: {
            normal: {
              color: 'rgba(0,0,0,0)',
              borderWidth: 2,
              borderColor: 'rgba(1, 239, 253, .2)',
              padding: 0
            }
          },
          hoverAnimation: false,
          legendHoverLink: false,
          z: -10,
          data: [100],
        }],
      };
    },
  },
}
</script>

<style scoped>

</style>